import React from 'react';
import PrivateRoute from '../hoc/PrivateRoute/PrivateRoute';
import AlterarClienteProcessoPage from '../pages/Manutencao/AlterarClienteProcesso/AlterarClienteProcessoPage';

function RoutesManutencaoComponents() {
  return (
    <>
      <PrivateRoute
        path="/manutencao/alterar-cliente-processo"
        tipoUsuario="U"
        roles={['2601']}
        exact
        component={AlterarClienteProcessoPage}
      />

    </>
  );
}

export const RoutesManutencao = RoutesManutencaoComponents;
